export default __webpack_public_path__ + "static/media/pin_login.980fb8ac.svg";